export const ENVELOPE_CURVE_CONSTANTS = {
  MIN_POINTS: 2,
  MAX_POINTS: 100,
  MIN_VALUE: -1_000_000,
  MAX_VALUE: 1_000_000,
  NAME_MAX_LENGTH: 100,
} as const;

export const COLUMN_SEPARATORS = {
  TAB: '\t',
  SEMICOLON: ';',
  COMMA: ',',
} as const;

export const DECIMAL_SEPARATORS = {
  COMMA: ',',
  POINT: '.',
} as const;
